export const FEATURES = {
  CONTACTS: 'contacts',
  SUGGEST_CONTENT: 'suggest-content',
  SUGGEST_KEYWORDS: 'suggest-keywords',
  IMPROVED_SEARCH: 'improved-search',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  ROTATIONS: 'rotations',
  KNOWLEDGE_ITEMS_EMBEDDINGS: 'knowledge-items-embeddings',
  AI_ASK_PANDA: 'ai-ask-panda',
  APPROVAL_MARK: 'approval-mark',
  AUTO_EXTRACT_METADATA: 'auto-extract-metadata',
  KNOWLEDGE_HUB_SHARED: 'knowledge-hub-shared',
  KNOWLEDGE_HUB_ACCESS: 'knowledge-hub-access',
  PERMISSIONS_OWNER_RESTRICTION: 'permissions-owner-restriction',
  KNOWLEDGE_COMMENTS: 'knowledge-comments',
  PROVIDED_BY: 'provided-by',
  WORKSPACE_RESTRICTIONS: 'workspace-restrictions',
  QUALITY_METRICS: 'quality-metrics',
  MY_CONTENT: 'my-content',
  QUALITY_METRICS_CASES: 'quality-metrics-cases',
};
